<template>
  <div>
    <div>
      <titulo-instituicao-ensino @cadastrar="irPara" />

      <div class="row">
        <div class="col-12 col-md-4">
          <input-text
            v-model="filtro"
            :label="$t('GERAL.FILTRAR_POR_NOME_CPNJ')"
            :placeholder="$t('GERAL.FILTRAR_POR_NOME_CPNJ')"
            @enter="filtrar"
          />
        </div>
        <div class="col-12 col-md-auto mb-2">
          <b-button
            class="w-100 botao-acao-filtro mb-3 mb-md-0"
            variant="primary"
            @click="filtrar"
          >
            {{ $t('GERAL.PESQUISAR') }}
          </b-button>
        </div>
        <div class="col-12 col-md-auto mb-2">
          <b-button
            class="w-100 botao-acao-filtro mb-3 mb-md-0"
            variant="secondary"
            @click="limparFiltro"
          >
            {{ $t('GERAL.LIMPAR') }}
          </b-button>
        </div>
      </div>

      <tabela
        :instituicoes="instituicoes"
        @excluir="confirmarExclusao"
        @alterar-ordenacao="novaOrdenacao"
      />
    </div>

    <paginacao :total="total" v-model="paginacao" @input="filtrar" />
  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import Permisoes from '@/components/mixins/permissoes';
import mensagem from '@/common/utils/mensagem';
import rotas from '@/common/utils/rotas';

// Services:
import InstituicaoEnsinoService from '@/common/services/instituicao-ensino/instituicao-ensino.js';

// Components:
import TituloInstituicaoEnsino from '@/views/academico/outras-instituicoes/instituicao-ensino/components/TituloInstituicaoEnsino';
import Tabela from './components/Tabela';
import Paginacao from '@/components/paginacao/Paginacao';
import { InputText } from '@/components/inputs';

export default {
  name: 'Index',
  mixins: [Permisoes],
  components: {
    TituloInstituicaoEnsino,
    InputText,
    Tabela,
    Paginacao,
  },
  data() {
    return {
      instituicoes: [],
      filtro: '',
      total: 0,
      paginacao: { numeroDaPagina: 1, tamanhoDaPagina: 10 },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    this.filtrar();
  },
  methods: {
    limparFiltro() {
      this.filtro = '';
      this.paginacao.numeroDaPagina = 1;
      this.filtrar();
    },
    // FUNÇÕES OBTENÇÃO DE DADOS:
    filtrar() {
      this.$store.dispatch(START_LOADING);
      // Remove apenas a pontuação de máscara de CNPJ (mantendo letras/dígitos/espaços do nome),
      // já que o back-end busca CNPJ e nome no mesmo campo sobre uma coluna sem pontuação.
      InstituicaoEnsinoService.obterInstituicaoEnsinoPorFiltro(
        this.filtro.replace(/[./-]/g, ''),
        this.paginacao,
        this.campoOrdenado,
        this.ordem
      )
        .then(({ data }) => {
          this.instituicoes = data.itens;
          this.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES CRUD:
    async confirmarExclusao(item) {
      const respostaExclusao = await mensagem.confirmacao(
        this.$t('ACADEMICO.CONFIRMAR_EXCLUSAO_DE').formatUnicorn({
          item: item.nome,
        }),
        this.$t('ACADEMICO.AVISO_NAO_PODE_DESFAZER_ACAO')
      );
      respostaExclusao.isConfirmed ? this.excluir(item.id) : {};
    },
    excluir(item) {
      this.$store.dispatch(START_LOADING);
      InstituicaoEnsinoService.excluir(item)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Instituição deletada!');
          this.filtrar();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES AUXILIARES:
    irPara(rota, id) {
      rotas.irPara(rota, id);
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.filtrar();
    },
  },
};
</script>
